<template>
  <div class="flex items-center">
    <IconCheckInCircle class="text-static-success-hi mr-12" />
    <span class="body-1">
      {{ i18n(translations.label) }}
    </span>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { IconCheckInCircle } from '@ds/icons/IconCheckInCircle'

import translations from './StatusVerified.translations'

const i18n = useI18n()
</script>
